"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _util = require("../../../util");
var _PaymentStyled = require("../PaymentStyled");
/* eslint-disable react/jsx-props-no-spreading */

var LegalNote = function LegalNote(_ref) {
  var _ref$order = _ref.order,
    discount = _ref$order.discount,
    currency = _ref$order.currency,
    offerPrice = _ref$order.priceBreakdown.offerPrice,
    period = _ref.period;
  var isInTrial = (discount === null || discount === void 0 ? void 0 : discount.applied) && discount.type === 'trial';
  var couponApplied = (discount === null || discount === void 0 ? void 0 : discount.applied) && discount.type !== 'trial';
  var readablePrice = "".concat(_util.currencyFormat[currency]).concat(offerPrice);
  var readablePeriod = "".concat(period ? "/".concat(period) : '');
  var CLEENG_MY_ACCOUNT_URL = 'CLEENG_MY_ACCOUNT_URL';
  var generateLinkAttributes = function generateLinkAttributes(href) {
    return {
      href: (0, _util.getData)(href),
      target: '_blank',
      rel: 'noreferrer',
      style: (0, _util.getData)(href) ? {
        textDecoration: 'underline'
      } : {}
    };
  };
  return /*#__PURE__*/_react.default.createElement(_PaymentStyled.LegalNoteWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentStyled.LegalTextStyled, {
    marginBottom: "12px"
  }, function () {
    if (isInTrial) {
      return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
        i18nKey: "legal-notes.trial.period-".concat(period)
      }, /*#__PURE__*/_react.default.createElement("strong", null, "After any free trial and/or promotional period, you will be charged ", {
        readablePrice: readablePrice
      }, {
        readablePeriod: readablePeriod
      }, " or the then-current price plus applicable taxes on a recurring basis."), ' ', "If you do not cancel the service during its free trial period, you will be charged. Your subscription will automatically continue until you cancel. To cancel, log into", ' ', /*#__PURE__*/_react.default.createElement("a", generateLinkAttributes(CLEENG_MY_ACCOUNT_URL), "your account"), ' ', "and click 'Manage Subscription'.");
    }
    if (couponApplied) {
      return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
        i18nKey: "legal-notes.discount.period-".concat(period)
      }, /*#__PURE__*/_react.default.createElement("strong", null, "After any free trial and/or promotional period, you will be charged ", {
        readablePrice: readablePrice
      }, {
        readablePeriod: readablePeriod
      }, " or the then-current price plus applicable taxes on a recurring basis."), ' ', "Your subscription will automatically continue until you cancel. To cancel, log into", ' ', /*#__PURE__*/_react.default.createElement("a", generateLinkAttributes(CLEENG_MY_ACCOUNT_URL), "your account"), ' ', "and click 'Manage Subscription'.");
    }
    return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "legal-notes.period-".concat(period)
    }, /*#__PURE__*/_react.default.createElement("strong", null, "By clicking 'Pay', you will be charged", ' ', {
      readablePrice: readablePrice
    }, {
      readablePeriod: readablePeriod
    }, " or the then-current price plus applicable taxes on a recurring basis."), "Your subscription will automatically continue until you cancel. To cancel, log into", ' ', /*#__PURE__*/_react.default.createElement("a", generateLinkAttributes(CLEENG_MY_ACCOUNT_URL), "your account"), ' ', "and click 'Manage Subscription'.");
  }()));
};
LegalNote.propTypes = {
  order: _propTypes.default.objectOf(_propTypes.default.any),
  period: _propTypes.default.string
};
LegalNote.defaultProps = {
  order: {},
  period: null
};
var _default = LegalNote;
exports.default = _default;